import { makeStyles, Theme, useTheme } from "@material-ui/core";
import React, { ReactElement, useEffect, useState } from "react";
import axios from "axios";
import { RedocStandalone } from "redoc";
import { useAuth } from "../contexts/AuthContext";
import { ViEnvVariableNotSetError } from "../models/Errors";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    overflowY: "scroll",
    maxHeight: "100%",
  },
}));

const url = process.env.REACT_APP_PUBLIC_API_SPEC_URL;
if (!url) throw new ViEnvVariableNotSetError("REACT_APP_PUBLIC_API_SPEC_URL");

function Docs({ title }: { title?: string }): ReactElement {
  const classes = useStyles();
  const { getAccessTokenSilently } = useAuth();
  const [apiSpec, setApiSpec] = useState<any>(null);
  const theme = useTheme();
  const options = {
    theme: {
      colors: {
        primary: { main: theme.palette.secondary.main },
      },
    },
  };

  useEffect(() => {
    (async function fetchApiSpec() {
      const { data } = await axios.get(url!, {
        headers: {
          Authorization: `Bearer ${await getAccessTokenSilently()}`,
        },
      });
      setApiSpec(data);
    })();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    document.title = title || "VI Core | Docs";
  }, [title]);

  return (
    <div className={classes.wrapper}>
      {apiSpec && <RedocStandalone {...{ options }} spec={apiSpec} />}
    </div>
  );
}

export default Docs;
